module.exports = __webpack_public_path__ + "img/6.b0d5e8f1.png";